export const DIAMOND = 'diamond';
export const ELITE = 'elite';
export const GOLD = 'gold';
export const PLATINUM = 'platinum';